import { WifiOff, X } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useOnlineStatus } from '../hooks/useAsync';

function OfflineBanner() {
  const { t } = useTranslation('errors');
  const isOnline = useOnlineStatus();
  const [isDismissed, setIsDismissed] = useState(false);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    if (!isOnline) {
      setShowBanner(true);
      setIsDismissed(false);
      return;
    }
    // Delay hiding to allow animation
    const timeout = setTimeout(() => setShowBanner(false), 300);
    return () => clearTimeout(timeout);
  }, [isOnline]);

  if (!showBanner || isDismissed) {
    return null;
  }

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-offline bg-amber-500 text-white px-4 py-3 shadow-lg transition-transform duration-300 ${
        isOnline ? 'translate-y-full' : 'translate-y-0'
      }`}
      role="alert"
      aria-live="polite"
    >
      <div className="container mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <WifiOff className="w-5 h-5 flex-shrink-0" />
          <div>
            <p className="font-medium">{t('network.noConnection')}</p>
            <p className="text-sm text-amber-100">
              {t('networkError.offlineDescription')}
            </p>
          </div>
        </div>
        <button
          onClick={() => setIsDismissed(true)}
          className="p-1 hover:bg-amber-600 rounded transition-colors"
          aria-label={t('inlineError.dismiss')}
        >
          <X className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}

export default OfflineBanner;
